import Check from '../src/icon/check';
export default Check;